



























































import { Component, Vue } from 'vue-property-decorator'

import {
  BindPaymentMethodModal,
  NetworkErrorEmptyState,
  PaymentMethodTile,
  VsLoading
} from '@/components'

import { Action, Getter } from 'vuex-class'

import { EmptyState, MobileLayout } from '@/layouts/components'

import { AsyncState, ModalState, PaymentMethod, PaymentMethodPayload } from '@/models'

import { isFood } from '@/utils'

@Component({
  components: {
    BindPaymentMethodModal,
    EmptyState,
    MobileLayout,
    NetworkErrorEmptyState,
    PaymentMethodTile,
    VsLoading
  }
})
export default class PaymentMethods extends Vue {
  loadState = new AsyncState()
  bindState = new ModalState()

  get isWaiting () {
    return this.bindState.isPending
  }

  get showFab () {
    return this.loadState.isResolved
  }

  get emptyStateIcon () {
    return isFood() ? 'restaurant_menu' : 'list_alt'
  }

  @Getter('paymentMethods/orderedAllowedPaymentMethods')
  readonly allowedPaymentMethods!: PaymentMethod[]

  @Getter('paymentMethods/unbidedPaymentMethods')
  readonly paymentMethods!: PaymentMethod[]

  @Action('paymentMethods/loadAllowedPaymentMethodList')
  loadAllowedPaymentMethodList!: () => Promise<void>

  @Action('paymentMethods/loadPaymentMethodList')
  loadPaymentMethodList!: () => Promise<void>

  @Action('paymentMethods/bindPaymentMethod')
  bindPaymentMethod!: (payload: PaymentMethodPayload) => Promise<void>

  created () {
    if (this.allowedPaymentMethods.length === 0 || this.paymentMethods.length === 0) {
      this.reload()
    } else {
      this.loadState.touch()
    }
  }

  async reload () {
    try {
      await this.loadState.handle(
        this.loadAllowedPaymentMethodList()
      )
      await this.loadState.handle(
        this.loadPaymentMethodList()
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleBindPaymentMethod (payload: PaymentMethodPayload) {
    try {
      await this.bindState.handle(
        this.bindPaymentMethod(payload)
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível adicionar o método de pagamento.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }
}
